import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LanguageService } from '@core/service/language.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class LanguageInterceptor implements HttpInterceptor {
  constructor(private translateService: TranslateService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Get the current lang from the service.
    const lang = this.translateService.currentLang || 'fr';

    // Clone the request and replace the original headers with
    // cloned headers, updated with the lang.
    const langReq = request.clone({
      headers: request.headers.set('Accept-Language', lang),
    });

    // send cloned request with header to the next handler.
    return next.handle(langReq);
  }
}
